import React from 'react';
import cn from 'classnames';
import { Visibility } from '../../../types/common-types';
import './style.scss';

export interface MenuItemProps {
  id?: string;
  label: string;
  value: string;
  focus?: string;
  onClick?: (value: string) => void;
  visibility?: Visibility;
  activeItem?: string;
  className?: string;
  styleName?: string;
}

const MenuItem: React.FC<MenuItemProps> = ({
  id = '',
  label,
  onClick,
  value,
  visibility = Visibility.Visible,
  activeItem,
  className,
  focus = false,
}) => {
  const handleClick = () => {
    if (visibility === Visibility.Visible) {
      if (onClick) onClick(value);
    }
  };
  return (
    <div
      id={id}
      className={className}
      styleName={cn('menuItem', {
        disabled: visibility === Visibility.Disabled,
        hidden: visibility === Visibility.Hidden,
        active: value === activeItem,
        focus,
      })}
      tabIndex={focus ? 0 : -1}
      role="button"
      onClick={handleClick}
      onKeyPress={handleClick}
      data-cy-value={value}
      data-title={label}
    >
      <div styleName="menuItem__label">{label}</div>
    </div>
  );
};
export default MenuItem;
